export const messages = {
  title: { id: 'admin/promotions.form.conditions.utm' },
  subtitle: { id: 'admin/promotions.form.conditions.utm.subtitle' },
  utmSource: { id: 'admin/promotions.form.conditions.utm.source' },
  utmCampaign: { id: 'admin/promotions.form.conditions.utm.campaign' },
  utmDescription: {
    utmSource: {
      id: 'admin/promotions.form.conditions.utm.utm-source.description',
    },
    utmCampaign: {
      id: 'admin/promotions.form.conditions.utm.utm-campaign.description',
    },
  },
  invalidChars: { id: 'admin/promotions.form.conditions.utm.invalid' },
  connector: { id: 'admin/promotions.form.rule.connector.and' },
  moreInformation: {
    id: 'admin/promotions.links.conditions.utm.more-information',
  },
}
